import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import routes from '../../core/routes'
import { useStore } from '../../stores'
import { AuthErrorText, AuthForm, Box, Button, TextField } from '../index'

const LoginSms = observer((): JSX.Element => {
  const { t } = useTranslation()
  const { loginStore, applicationStore } = useStore()
  const navigate = useNavigate()
  const [authorizationCode, setAuthorizationCode] = useState<string>('')
  const [isShowError, setIsShowError] = useState<boolean>(false)

  return (
    <Box data-cy="login-sms-container">
      {isShowError && (
        <AuthErrorText data-cy="login-sms-error-message">
          {t('smsNotValid')}
        </AuthErrorText>
      )}
      <AuthForm
        data-cy="login-sms-form"
        onSubmit={async (e) => {
          e.preventDefault()
          setIsShowError(false)
          try {
            const dataUser = await loginStore.getToken(authorizationCode)

            navigate(routes.lobby)

            await applicationStore.fpJsClient?.getVisitorData({
              linkedId: dataUser.login,
              tag: {
                userAction: `login`,
              },
            })
          } catch {
            setIsShowError(true)
          }
        }}>
        <Box mb={40}>
          <TextField
            id="smsCodeLogin"
            label={t('enterCodeFromSms')}
            value={authorizationCode}
            data-cy="login-sms-input"
            onChange={(e) => {
              setAuthorizationCode(e.target.value)
            }}
          />
        </Box>
        <Button
          fullWidth
          type="submit"
          label={t('continue')}
          data-cy="login-sms-submit-button"
        />
      </AuthForm>
    </Box>
  )
})

export default LoginSms
